import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getUserHomePath } from '../../shared/config/env';
import { useMetaTags } from '../../shared/hooks/useMetaTags';
import './NotFound.css';

/**
 * 404 Not Foundページコンポーネント
 */
function NotFound() {
  const navigate = useNavigate();
  const homePath = getUserHomePath();

  // メタタグを設定
  useMetaTags({
    title: '404 - ページが見つかりません | ブログ',
    description: 'お探しのページは見つかりませんでした。',
  });

  // 5秒後に自動的にホームにリダイレクト
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(homePath, { replace: true });
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, homePath]);

  return (
    <div className="not-found">
      <div className="not-found__container">
        <div className="not-found__animation">
          <div className="not-found__number">4</div>
          <div className="not-found__cat">
            <div className="not-found__cat-body">
              <div className="not-found__cat-ear not-found__cat-ear--left"></div>
              <div className="not-found__cat-ear not-found__cat-ear--right"></div>
              <div className="not-found__cat-face">
                <div className="not-found__cat-eye not-found__cat-eye--left"></div>
                <div className="not-found__cat-eye not-found__cat-eye--right"></div>
                <div className="not-found__cat-nose"></div>
                <div className="not-found__cat-mouth"></div>
              </div>
            </div>
            <div className="not-found__cat-tail"></div>
          </div>
          <div className="not-found__number">4</div>
        </div>
        <h1 className="not-found__title">ページが見つかりません</h1>
        <p className="not-found__message">
          お探しのページは存在しないか、移動または削除された可能性があります。
        </p>
        <div className="not-found__actions">
          <Link to={homePath} className="not-found__button not-found__button--primary">
            ホームに戻る
          </Link>
          <button
            onClick={() => navigate(-1)}
            className="not-found__button not-found__button--secondary"
          >
            前のページに戻る
          </button>
        </div>
        <p className="not-found__auto-redirect">
          5秒後に自動的にホームページにリダイレクトされます
        </p>
      </div>
    </div>
  );
}

export default NotFound;

